import { fromFetch } from 'rxjs/fetch';
import { catchError, of, switchMap } from 'rxjs';
import { SubjectManager } from '../managers/SubjectManager';
import { ErrorType } from '../enums/ErrorType';
import { ValidationError } from '../errors/ValidationError';
import { GLOBAL } from '../constants/Global';
import { IError } from '../interfaces/IError';
import { IServerError } from '../interfaces/IServerError';
import ReactGA from 'react-ga4';
import { ModulesTypes } from '../enums/ModulesTypes';
import { AnalyticsLabelsType } from '../../analytics/enums/AnalyticsLabelsType';
import { AnalyticsActionsType } from '../../analytics/enums/AnalyticsActionsType';

export const errors$ = new SubjectManager();

export const handleError = (error: any): any => {
	console.error('ApiHttpClient Error  --> ', error.message);
	const errorsJson: IServerError = JSON.parse(error.message);
	const title = errorsJson.message || errorsJson;
	const appError: IError = {
		toast: {
			title: title ? (title as any) : 'Server error',
			type: ErrorType.ERROR,
			show: true,
		},
		serverErrors: [errorsJson],
	};
	errors$.setSubject(appError);
	return of({ error: true, message: error.message });
};

export const ApiHttpClient = {
	get: (
		path: string,
		params?: any,
		additionalHeaders?: Headers,
		trackingCategory?: ModulesTypes
	) => {
		const url = new URL(`${GLOBAL.API_URL}/${path}`);
		if (params != null) {
			Object.keys(params).forEach(key => {
				url.searchParams.append(key, params[key]);
			});
		}

		return fromFetch(url as any, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		}).pipe(
			switchMap(async response => {
				if (response.ok) {
					return await response.json();
				} else {
					if (trackingCategory) {
						ReactGA.event({
							category: trackingCategory,
							action: AnalyticsActionsType.PRE_APPLICATION_LOAD_FAILED,
							label: AnalyticsLabelsType.PRE_APPLICATION_FORM_FAIL,
						});
					}

					const responseJson = await response.json();
					const firstError = responseJson.errors.shift();
					throw new ValidationError(
						`${firstError.validator || firstError.key}`,
						`${firstError.title}`
					);
				}
			}),
			catchError(handleError)
		);
	},
	post: (path: string, payload: any, trackingCategory?: ModulesTypes) => {
		const url = new URL(`${GLOBAL.API_URL}/${path}`);
		return fromFetch(url as any, {
			method: 'POST',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		}).pipe(
			switchMap(async (response, e) => {
				if (response.ok) {
					return await response.json();
				} else {
					if (trackingCategory) {
						ReactGA.event({
							category: trackingCategory,
							action: AnalyticsActionsType.PRE_APPLICATION_FILL_FAILED,
							label: AnalyticsLabelsType.PRE_APPLICATION_FORM_FAIL,
						});
					}
					const responseJson = await response.json();
					const stringError = JSON.stringify(responseJson.detail);
					throw new ValidationError(stringError);
				}
			}),
			catchError(handleError)
		);
	},
};
